import React, {useState} from 'react';
import {Button, Chip} from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import PaymentIcon from '@mui/icons-material/Payment';
import {
    ActiveDate,
    ButtonRow,
    CardHeader,
    CardWrapper,
    FeatureList,
    PriceRow,
    PriceText,
    TariffName,
    Title,
} from './styles';
import {useDashboardContext} from "../../../Dashboard";
import {Loading} from "../../../../Loading";

export default function TariffCard({onOpenPayment}) {
    const {PAYMENT_DATA, TARIFF_DATA, tariff, isPaid, isTrial} = useDashboardContext();

    return (
        <CardWrapper>
            <CardHeader>
                <Title>{TARIFF_DATA.title}</Title>
                <Chip
                    icon={<StarIcon style={{fontSize: 14}}/>}
                    label={isTrial || isPaid ? TARIFF_DATA.active : TARIFF_DATA.unActive}
                    color={isTrial || isPaid ? "success" : "error"} size="small"
                />
            </CardHeader>

            <TariffName>{tariff.nameText}</TariffName>

            <PriceRow>
                <PriceText><nobr>{tariff.priceText}</nobr></PriceText>
                <ActiveDate style={{textAlign: "right"}}>
                    {
                        isTrial ? (
                            TARIFF_DATA.trialUntil
                        ) : (
                            isPaid ? (
                                 TARIFF_DATA.paidUntil
                            ) : (
                                TARIFF_DATA.paidExpires
                            )
                        )
                    }
                </ActiveDate>
            </PriceRow>

            <FeatureList>{tariff.features?.map((feature, index) => (<li key={index}>{feature}</li>))}</FeatureList>

            <ButtonRow>
                <Button variant="contained" color="primary"  startIcon={<PaymentIcon/>}
                        onClick={() => onOpenPayment(tariff.priceMonthly)}
                        style={{fontSize: 12, textTransform: 'none', borderRadius: 8, backgroundColor: '#d81b60'}}>
                    <div>
                        <div>{PAYMENT_DATA.payButtonText}</div>
                        <nobr>{tariff.priceText}</nobr>
                    </div>
                </Button>
                <Button variant="contained" color="primary"  startIcon={<PaymentIcon/>}
                        onClick={() => onOpenPayment(tariff.priceAnnual)}
                        style={{fontSize: 12, textTransform: 'none', borderRadius: 8, backgroundColor: '#d81b60'}}>
                    <div>
                        <div>{PAYMENT_DATA.payButtonAnnualText}</div>
                        <nobr>{tariff.priceAnnualText}</nobr>
                    </div>
                </Button>
            </ButtonRow>
        </CardWrapper>
    );
}

export function Tariffs({onOpenPayment}) {
    const {tariffs, tariff_id, onSelectTariff} = useDashboardContext();
    return (
        <div>
            {tariffs.map(tariff => (
                tariff.id === tariff_id ? (
                    <TariffCard key={tariff.id} onOpenPayment={onOpenPayment}/>
                ) : (
                    <TariffCardOther key={tariff.id} tariff={tariff} onSelectTariff={() => onSelectTariff(tariff.id)}/>
                )
            ))}
        </div>
    );
}

export function TariffCardOther({onSelectTariff, tariff}) {
    const {TARIFF_DATA} = useDashboardContext();

    const [loading, setLoading] = useState();

    const onSelectTariffLoading = async () => {
        setLoading(true);
        await onSelectTariff();
        setLoading(false);
    }

    return (
        <CardWrapper>
            {loading && <Loading/>}
            <TariffName>{tariff.nameText}</TariffName>
            <PriceRow><PriceText>{tariff.priceText}</PriceText></PriceRow>

            <FeatureList>{tariff.features?.map((feature, index) => (<li key={index}>{feature}</li>))}</FeatureList>

            <ButtonRow>
                <Button
                    variant="contained"
                    color={"inherit"}
                    onClick={onSelectTariffLoading}
                    style={{textTransform: 'none', borderRadius: 8,}}
                >
                    {TARIFF_DATA.changeTariffButton}
                </Button>
            </ButtonRow>
        </CardWrapper>
    );
}
